'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dDanger$002dAlert$0024$0024anon$002413 from "./presto.-Danger-Alert$$anon$13.js";
var $p;
/** @constructor */
function $c_Lpresto_DangerAlert$$anon$12() {
  this.aHO = null;
  this.aHM = null;
  this.aHN = false;
  this.aHK = null;
  this.aHL = false;
  this.aHP = false;
  this.aHQ = false;
  this.aHO = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_DangerAlert$$anon$12 as $c_Lpresto_DangerAlert$$anon$12 };
$p = $c_Lpresto_DangerAlert$$anon$12.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_DangerAlert$$anon$12;
/** @constructor */
function $h_Lpresto_DangerAlert$$anon$12() {
}
export { $h_Lpresto_DangerAlert$$anon$12 as $h_Lpresto_DangerAlert$$anon$12 };
$h_Lpresto_DangerAlert$$anon$12.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.aHO;
});
$p.t = (function() {
  if ((!this.aHN)) {
    this.aHM = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("uef", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aHN = true;
  }
  return this.aHM;
});
$p.ae = (function() {
  if ((!this.aHL)) {
    this.aHK = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dDanger$002dAlert$0024$0024anon$002413.$c_Lpresto_DangerAlert$$anon$13(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aHL = true;
  }
  return this.aHK;
});
$p.w = (function() {
  if ((!this.aHQ)) {
    this.aHP = false;
    this.aHQ = true;
  }
  return this.aHP;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_DangerAlert$$anon$12 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_DangerAlert$$anon$12, "presto.DangerAlert$$anon$12", ({
  Gd: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_DangerAlert$$anon$12 as $d_Lpresto_DangerAlert$$anon$12 };
//# sourceMappingURL=presto.-Danger-Alert$$anon$12.js.map
